import { Container } from "@material-ui/core"
import type { ReactElement, ReactNode } from "react"
import { SpinnerContainer } from "../../atoms"

import "./page-container.styles.scss"

export interface IPageContainerProps {
  id: string
  children?: ReactNode
  noPadding?: boolean | undefined
  smallPadding?: boolean | undefined
  hasLoaded?: boolean | undefined
}

export function PageContainer(props: IPageContainerProps): ReactElement {
  const { id, children, noPadding, smallPadding, hasLoaded } = props

  function getClassName(): string {
    if (noPadding) {
      return "page-container padding-0"
    }
    if (smallPadding) {
      return "page-container padding-small"
    }
    return "page-container"
  }

  if (hasLoaded || hasLoaded === undefined) {
    return (
      <Container id={id} className={getClassName()}>
        {children ? children : <></>}
      </Container>
    )
  }

  return <SpinnerContainer />
}
